import { GetterTree } from 'vuex';

import { RootState } from '@/store';
import { State } from './state';
import {
    FilterCheckData,
    FilterControlIdentifier,
    FilterSection,
    FilterSectionCheck, FilterSectionSlide,
    FilterSlideData, FilterSlideIdentifier, FilterSlideRange,
    FilterSort
} from "@/types";

export type Getters = {
    getFilterTitle(state: State): string;
    getCancelFilterLabel(state: State): string;
    getSort(state: State): FilterSort | null;
    getResultsCount(state: State): number;
    getResultsTotalLabel(state: State): string;
    getCategorySortLabel(state: State): string;
    getFilterControl(state: State): (controlIdentifier: FilterControlIdentifier) => FilterCheckData | undefined;
    getFilterSlide(state: State): (slideIdentifier: FilterSlideIdentifier) => FilterSlideData | undefined;
    getSlideMinMax(state: State): (slideData: FilterSlideData) => number;
    getFilterSelection(state: State): FilterCheckData[] | [];
    getChangedSlides(state: State): FilterSlideData[] | [];
    getBaseUrl(state: State): string;
    getUrlQuery(state: State, getters: Getters): URLSearchParams;
    getShowLessLabel(state: State): string;
    getShowMoreLabel(state: State): string;
    getIsOpenedFilterModal(state: State): boolean;
}

export const getters: GetterTree<State, RootState> & Getters = {
    getLoadingProductsLabel: state => state.loadingProductsLabel,
    getFilterTitle: state => state.filterTitle,
    getCancelFilterLabel: state => state.cancelFilterLabel,
    getSort: state => state.sort,
    getResultsCount: state => state.resultsTotalCount,
    getResultsTotalLabel: state => state.resultsTotalLabel,
    getCategorySortLabel: state => state.categorySortLabel,
    getFilterControl: (state) => (controlIdentifier: FilterControlIdentifier) => {
        let control: FilterCheckData | undefined;
        state.sections.forEach((filterSection: FilterSection) => {
            if (control === undefined && filterSection.type === "check") {
                control = filterSection.data.find((filterControl: FilterCheckData) => {
                    return controlIdentifier.name === filterControl.name && (controlIdentifier.value ? controlIdentifier.value === filterControl.value : true)
                });
            }
        });

        return control;
    },
    getFilterSlide: (state) => (slideIdentifier: FilterSlideIdentifier) => {
        const slideSection = state.sections.find((section: FilterSection) => section.type === "slide");
        if (slideSection?.type === "slide") {
            return slideSection.data.find(slide => slide.nameMin === slideIdentifier.type || slide.nameMax === slideIdentifier.type);
        }

        return undefined;
    },
    getSlideMinMax: (state) => (slideData: FilterSlideData) => {
        return slideData.minValue
    },
    getFilterSelection: (state) => {
        let controlsArray: FilterCheckData[] | [] = [];
        state.sections.forEach((filterSection: FilterSection) => {
            if (filterSection.type === "check") {
                controlsArray = [
                    ...controlsArray,
                    ...filterSection.data.filter((filterControl: FilterCheckData) => filterControl.checked)
                ];
            }
        });

        return controlsArray;
    },
    getChangedSlides: (state) => {
        let slidesArray: FilterSlideData[] | [] = [];
        state.sections.forEach((filterSection: FilterSection) => {
            if (filterSection.type === "slide") {
                slidesArray = [
                    ...slidesArray,
                    ...filterSection.data.filter((slide: FilterSlideData) => slide.minParam || slide.maxParam)
                ];
            }
        });

        return slidesArray;
    },
    getBaseUrl: (state) => {
        const url = state.url
        return url.indexOf("?") > 0 ? url.substring(0, url.indexOf('?')) : url;
    },
    getUrlQuery: (state, getters) => {
        const queryParams = new URLSearchParams({});

        if (state.sort) {
            queryParams.append(state.sort.name, state.sort.selected);
        }

        const slides = getters.getChangedSlides;
        Array.isArray(slides) && slides.forEach((slide: FilterSlideData) => {
            queryParams.append(slide.nameMin, slide.minParam.toString());
            queryParams.append(slide.nameMax, slide.maxParam.toString());
        });

        const checked = getters.getFilterSelection;
        Array.isArray(checked) && checked.forEach((control: FilterCheckData) => {
            queryParams.append(control.name, control.value);
        });

        return queryParams;
    },
    getShowLessLabel: state => state.showLessLabel,
    getShowMoreLabel: state => state.showMoreLabel,
    getIsOpenedFilterModal: state => state.isOpenedFilterModal,
};
